import { SxProps, Theme } from "@mui/material";

export const businessCardStyles = {
  card: (theme: Theme): SxProps<Theme> => ({
    // width: "382px",
    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: "8px",
    border: "1px solid #D6D6DA",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    fontFamily: theme.typography.fontFamily,
    // [theme.breakpoints.up("sm")]: {
    //   width: "350px",
    // },
  }),
  bestSellerChip: {
    position: "absolute",
    margin: "12px",
    backgroundColor: "#F2F2F2",
    fontWeight: "600",
  },
  cardContent: (theme: Theme) => ({
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      // minHeight: "197px",
    },
  }),
  businessNameTypography: (theme: Theme) => ({
    fontSize: "17px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "25.5px",
    letterSpacing: "0.347px",
    fontFamily: theme.typography.fontFamily,
  }),

  filledButton: {
    marginTop: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#328734",
    "&:hover": {
      backgroundColor: "#328734",
    },
    borderRadius: "8px"
  },
  deleteButton: {
    marginTop: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#875b32ff",
    "&:hover": {
      backgroundColor: "#876c32ff",
    },
    borderRadius: "8px"
  },
  messageImage: {
    marginRight: "8px",
  },
  filledButtonTypography: (theme: Theme) => ({
    fontSize: "13px",
    fontWeight: 500,
    color: "#fff",
    fontFamily: theme.typography.fontFamily,
    padding: "2px 0"
  }),

  unFilledButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #000",
    width: "100%",
    borderRadius: "8px"
  },
  unFilledButtonTypography: (theme: Theme) => ({
    color: "#000",
    fontSize: "13px",
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
  }),
};
